import React from "react";
import {C} from "../styles";
import "./EmailVerificationNotice.css";

// Durée de validité du lien de vérification, fixée côté serveur (POST /register et
// /resend-verification : 24 h). À garder alignée si elle change.
export const VERIFICATION_LINK_VALIDITY_HOURS = 24;

// Encadré affiché juste après l'inscription : beaucoup d'agents ne voyaient pas le simple
// message texte et oubliaient de cliquer sur le lien reçu, laissant leur compte inactif.
export default function EmailVerificationNotice({email, pseudo, nextStep}) {
    return (
        <div role="alert" style={{
            backgroundColor: C.accentLight,
            border: `2px solid ${C.danger}`,
            borderLeftWidth: 8,
            borderRadius: 12,
            boxShadow: "0 4px 14px rgba(192, 57, 43, 0.18)",
            padding: "16px 18px",
            margin: "0 0 16px",
            color: C.text,
        }}>
            <p style={{display: "flex", alignItems: "center", gap: 10, margin: "0 0 10px", fontSize: 19, fontWeight: 800, color: C.dangerDark}}>
                <span className="email-verification-notice__icon" aria-hidden="true" style={{fontSize: 26}}>⚠️</span>
                Dernière étape : confirmez votre adresse
            </p>
            <p style={{margin: "0 0 8px", fontSize: 16, lineHeight: 1.45}}>
                Votre compte n'est <strong>pas encore actif</strong>. Nous venons d'envoyer un email à{" "}
                {email ? <strong>{email}</strong> : "votre adresse professionnelle"}.
                Ouvrez-le et <strong>cliquez sur le lien de confirmation</strong>.
            </p>
            <p style={{margin: "0 0 8px", fontSize: 16, fontWeight: 700}}>
                ⏱️ Ce lien est valable {VERIFICATION_LINK_VALIDITY_HOURS} heures.
            </p>
            <p style={{margin: 0, fontSize: 14, lineHeight: 1.45}}>
                Pas d'email ? Regardez dans vos courriers indésirables.
                {pseudo && <> Ensuite, {nextStep} avec le pseudo <strong>{pseudo}</strong>.</>}
            </p>
        </div>
    );
}
